import { Button, TableCell, TableRow } from "@mui/material";
import MUIDataTable from "mui-datatables";
import { useContext, useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import CourseAssignmentContext from "../../context/500/CourseAssignmentContext";
import CourseAllocationComponentForReqCourses from "./CourseAllocationForReqCourses";
import ReasonOfDecline from "./ReasonOfDecline";
import RemoveOffBatch from "./RemoveOffBatch";

function RequestedCoursesComponent() {
  let [loading, setLoading] = useState(false);
  let [reqCourses, setReqCourses] = useState([]);
  let [ReqCoursesData, setReqCoursesData] = useState([]);
  let [dataForReasonPage, setdatafroReasonPage] = useState({});
  let [showReasonPage, setshowReasonPage] = useState(false);
  let [isMounted, setIsMounted] = useState(true);
  let [showremovetab, setshowremovetab] = useState(false);
  let [courestoremove, setcoursetoremove] = useState({});

  let {setoffbatchcourses, offbatchcourses}=useContext(CourseAssignmentContext)

  const columns = [
    {
      name: "Course Name",
      options: {
        filter: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <span
              style={{
                cursor:"pointer"
              }}
              onContextMenu={(e) => {
                checkoffbatchCourse(value, e);
              }} 
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "Code",
      options: {
        filter: false,
      },
    },
    {
      name: "Owner",
      options: {
        filter: true,
      },
    },
    {
      name: "Cr.Hr",
      options: {
        filter: false,
      },
    },
    {
      name: "LEH",
      options: {
        filter: false,
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div
              style={{
                fontSize: "17px",
                fontWeight: "600",
                color: getColorForStatus(value),
              }}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "Action",
      options: {
        filter: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          let buttonFunction;
          let declined = false;
          if (value.requested == false && value.declined == false) {
            buttonFunction = "Request";
          } else if (value.requested == true && value.declined == false) {
            buttonFunction = "Requested";
          } else if (value.requested == true && value.declined == true) {
            buttonFunction = "See Reason For Decline";
            declined = true;
          }

          return (
            <div>
              {declined == true ? (
                <Button
                  onClick={() => {
                    setdatafroReasonPage(value);
                    setshowReasonPage(true);
                  }}
                  sx={{
                    border: "1px solid #cd853f",
                    color: "#cd853f",
                    fontSize: "15px",
                    fontWeight: "600",
                  }}
                  variant="outlined"
                >
                  {buttonFunction}
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    sendRequestforStaffAllocation(
                      value.batch,
                      value.courseCode,
                      value.courseDept,
                      value.courseOwner
                    );
                  }}
                  sx={{
                    border: "1px solid #cd853f",
                    color: "#cd853f",
                    fontSize: "15px",
                    fontWeight: "600",
                  }}
                  variant="outlined"
                >
                  {buttonFunction}
                </Button>
              )}
            </div>
          );
        },
      },
    }, //for filter of batch on front end
    {
      name: "Batch",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Admission Type",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
    {
      name: "Program Type",
      options: {
        filter: true,
        display: false,
        viewColumns: false,
      },
    },
  ];

  let { batchOfReqCourses, setbatchOfReqCourses, setError } = useContext(
    CourseAssignmentContext
  );

  function checkoffbatchCourse(coursename, e) {
    e.preventDefault();

    offbatchcourses.forEach((course) => {
      if (coursename == course.course_name) {
        setshowremovetab(true);
        setcoursetoremove(course);
        return;
      }
    });
  }

  function getColorForStatus(stat) {
    let color = "red";
    if (stat.localeCompare("Pending...") == 0) {
      color = "rgb(130, 130, 130)";
    } else if (stat.localeCompare("Fully Assigned") == 0) {
      color = "green";
    } else if (stat.localeCompare("Partially Assigned") == 0) {
      color = "rgb(209, 209, 61)";
    }
    return color;
  }

  async function sendRequestforStaffAllocation(
    bID,
    courseCode,
    courseDept,
    courseOwner
  ) {
    let resp = await api.post("courseallocation/allocation/sendstaffrequest", {
      batchID: bID,
      courseCode,
      requester: courseDept,
      requested_to: courseOwner,
    });
    if (resp.data.msg == true) {
      staffRequestalignwithdatabase(courseCode);
    } else {
      alert(resp.data.msg);
    }
  }

  function staffRequestalignwithdatabase(courseCode) {
    let arr = [];
    reqCourses.forEach((req) => {
      if (req.course_code == courseCode) {
        req.declined = false;
        req.requested = true;
        req.requestStatus = "Pending...";
      }
      arr.push(req);
    });

    setReqCourses(arr);
  }

  let api = useAxiosPrivate();

  let getRequestedCourses = async (signal) => {
    try {
      let resp = await api.get(
        `courseallocation/allcurrentsemesterNotOwnedcourse?batch=${batchOfReqCourses}`,
        {
          signal,
        }
      );

      isMounted && setReqCourses(resp.data);
    } catch (err) {
      setError(err.response.data.msg);
    }
  };
  function alignReqCourses() {
    let arr = [];
    let offbatchcourses = [];


    reqCourses.forEach((course) => {
      let LEH = course.lab + course.lecture + course.advisory + course.tutorial;
      if (course.isOffBatch == "True") {
        offbatchcourses.push(course);
      }
      let arrfordata;
      if (course.reasonForDecline == null) {
        arrfordata = [
          course.course_name,
          course.course_code,
          course.ownername,
          course.credit_hr,
          LEH,
          course.requestStatus,
          {
            requested: course.requested,
            declined: course.declined,
            batch: course.batch,
            courseCode: course.course_code,
            curriculum: course.Course_Curriculum.curriculum_id,
            courseOwner: course.owner,
            courseDept: course.department,
          },
          course.year, //for filter of batch on front end
          course.admission_type,
          course.program_type,
        ];
      } else {
        arrfordata = [
          course.course_name,
          course.course_code,
          course.ownername,
          course.credit_hr,
          LEH,
          course.requestStatus,
          {
            requested: course.requested,
            declined: course.declined,
            batch: course.batch,
            courseCode: course.course_code,
            curriculum: course.Course_Curriculum.curriculum_id,
            courseOwner: course.owner,
            courseDept: course.department,
            courseDeclineReason: course.reasonForDecline,
          },
          course.year, //for filter of batch on front end
          course.admission_type,
          course.program_type,
        ];
      }

      arr.push(arrfordata);

    });

    setReqCoursesData(arr);
    setoffbatchcourses(offbatchcourses);

  }
  // eslint-disable-next-line

  useEffect(() => {
    setIsMounted(true);
    const controller = new AbortController();
    getRequestedCourses(controller.signal);

    return () => {
      setIsMounted(false);
      controller.abort();
    };
  }, []);
  useEffect(() => {
    alignReqCourses();
  }, [reqCourses]);

  useEffect(() => {
    getRequestedCourses();
  }, [batchOfReqCourses]);

  const options = {
    print: "false",
    download: "false",
    selectableRows: "none",
    filterType: "dropdown",
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 15],
    pagination: true,
    responsive: "vertical",
    expandableRows: true,

    renderExpandableRow: (rowData, rowMeta) => {
      const colSpan = rowData.length + 1;

      let currentcourse = reqCourses.filter(
        (course) => course.course_code == rowData[1]
      );
      let owner;
      let dept;
      if (currentcourse.length >= 1) {
        owner = currentcourse[0].owner;
        dept = currentcourse[0].department;
      } else {
        owner = null;
        dept = null;
      }

      return (
        <TableRow>
          <TableCell colSpan={colSpan}>
            <CourseAllocationComponentForReqCourses
              courseCode={rowData[1]}
              courseDept={dept}
              courseOwner={owner}
            />
          </TableCell>
        </TableRow>
      );
    },
  };

  return (
    <div className="ReqCourseTableWrapper">
      <div style={{ width: "90%" }}>
        {loading == false ? (
          <MUIDataTable
            title={"Course List"}
            data={ReqCoursesData}
            columns={columns}
            options={options}
          />
        ) : (
          <h1>loading</h1>
        )}
        {showReasonPage == true && (
          <ReasonOfDecline
            data={dataForReasonPage}
            setReqCourses={setReqCourses}
            reqCourses={reqCourses}
            setshowReasonPage={setshowReasonPage}
          />
        )}
        {showremovetab == true && (
          <RemoveOffBatch
            getCourses={getRequestedCourses}
            course={courestoremove}
            setshowremovetab={setshowremovetab}
          />
        )}
      </div>
    </div>
  );
}

export default RequestedCoursesComponent;
